// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oz-1";
export var messageSideRight = "_oz-2";
export var orderLookupBubbleContainer = "_oz-0";
export var submitButton = "_oz-3";